import { useEffect, useRef } from "react";

/** Close-on-outside-click / Escape behavior shared by the popover fields. */
export const useDismiss = <T extends HTMLElement = HTMLDivElement>(
  open: boolean,
  close: () => void,
) => {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) close();
    };
    const onEsc = (e: KeyboardEvent) => e.key === "Escape" && close();
    document.addEventListener("mousedown", onDown);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("keydown", onEsc);
    };
  }, [open, close]);
  return ref;
};
